import { elakay_API } from "../../config";
import {isAuthenticated  } from "../auth";
import {decryptData}  from '../auth/elakayCryptage'
import { elakayAutoText } from "../pageInside/dataElakay";
import { resolveUserAddingRoleToken } from "../../utils/userAddingRoleToken";
import { prepareUpload } from "../../utils/uploadPolicy";
import { readUploadResponse } from "../../utils/uploadResponse";



const normalizeToken = (value) => {
  if (typeof value !== "string") return "";
  const token = value.trim();
  if (!token || token === "undefined" || token === "null" || token === "false") return "";
  return token.split(".").length === 3 ? token : "";
};
const getAuthToken = () => normalizeToken(isAuthenticated()?.token);
const encodePathValue = (value) => encodeURIComponent(String(value || ""));
const normalizeMediaType = (value) => {
  const mediaType = String(value || "").toLowerCase();
  return ["image", "video"].includes(mediaType) ? mediaType : "";
};
const normalizeBoolean = (value) => value === true || value === "true";
const readJsonResponse = async (response) => {
  const text = await response.text();
  if (!text) return {};
  try {
    return JSON.parse(text);
  } catch (error) {
    throw new Error(`Réponse API invalide (${response.status}).`);
  }
};
const readEncryptedResponse = async (response) => {
  const payload = await readJsonResponse(response);
  if (!response.ok) {
    throw new Error(payload.error || payload.message || `Erreur API (${response.status}).`);
  }
  return decryptData(payload);
};
const bearerHeaders = (headers = {}) =>
  Object.fromEntries(
    Object.entries(headers)
      .map(([key, value]) => [key, normalizeToken(value)])
      .filter(([, value]) => value)
      .map(([key, value]) => [key, `Bearer ${value}`])
  );
export const AddTraductoTeam = (token, teamTraductor, up) => {
    return fetch(`${elakay_API}/language/AddTraductoTeam?upd=${up}`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(teamTraductor)
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};

export const allLanguageElakay = async (t) => {
    try{
   const response = await  fetch(`${elakay_API}/language/allLanguageElakay?t=${t}`, {
        method: "GET",
        headers: {
            ...bearerHeaders({ Authorization: getAuthToken() })
        }
    })
        // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

    const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors du chargement :", err);
   return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

const languageManagerRequest = async (path, options = {}) => {
  try {
    const response = await fetch(`${elakay_API}${path}`, {
      ...options,
      headers: {
        Accept: "application/json",
        ...(options.body ? { "Content-Type": "application/json" } : {}),
        ...bearerHeaders({ Authorization: getAuthToken() }),
        ...(options.headers || {}),
      },
    });
    return await readEncryptedResponse(response);
  } catch (error) {
    console.error("Language Manager:", error);
    return { success: false, error: error.message || "Une erreur inconnue est survenue" };
  }
};

export const getLanguageManagerAudit = () => (
  languageManagerRequest("/language/manager/audit", { method: "GET" })
);

export const syncLanguageJson = ({ confirm = false, choices = [] } = {}) => (
  languageManagerRequest("/language/manager/sync-json", {
    method: "POST",
    body: JSON.stringify({ confirm, choices }),
  })
);

export const syncLanguageObjectIds = ({ confirm = false } = {}) => (
  languageManagerRequest("/language/manager/sync-objectids", {
    method: "POST",
    body: JSON.stringify({ confirm }),
  })
);

export const LanguageElakayById = async (token, ID) => { 
      try{
   const response = await  fetch(`${elakay_API}/language/LanguageElakayById/${ID}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })
        // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }
   const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors du chargement :", err);
   return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const LanguageElakayByLanguage = async (info, t) => {

    // Single source of truth for this token (no URL param in this context, so
    // this only ever reads the localStorage fallback) — see utils/userAddingRoleToken.
    const token_userAdding = resolveUserAddingRoleToken();

      try{
   const response = await fetch(`${elakay_API}/language/LanguageElakayByLanguage?t=${t}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            ...bearerHeaders({
                Authorization: getAuthToken(),
                AuthorizationUserAdding: token_userAdding
            })
        },
        body: JSON.stringify(info)
    })
        // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

    const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

/**
 * Read-only role presentation documents (GET /language/role-documents).
 * The invitation token is passed explicitly by the caller (the URL token on
 * /user_Shoosing/:token) -- never re-read from localStorage here, so an old
 * saved token can never replace the one in the URL.
 * Without `role`, only the computed read access is returned.
 * Resolves { ok: true, data } or { ok: false, error: { status, code, network, message } }.
 */
export const getRoleDocuments = async ({ role, lang, invitationToken, eventToken, authToken, signal } = {}) => {
  const params = new URLSearchParams();
  if (role) params.set("role", role);
  if (lang) params.set("lang", lang);
  if (eventToken) params.set("eventToken", eventToken);
  try {
    const response = await fetch(`${elakay_API}/language/role-documents?${params.toString()}`, {
      method: "GET",
      signal,
      headers: {
        Accept: "application/json",
        ...bearerHeaders({
          Authorization: authToken === undefined ? getAuthToken() : authToken,
          AuthorizationUserAdding: invitationToken,
        }),
      },
    });
    const body = await readJsonResponse(response).catch(() => ({}));
    if (!response.ok) {
      return {
        ok: false,
        error: { status: response.status, code: body?.code || null, network: false, message: body?.error || "" },
      };
    }
    try {
      return { ok: true, data: await decryptData(body) };
    } catch (decryptError) {
      return { ok: false, error: { status: response.status, code: "INVALID_RESPONSE", network: false, message: "" } };
    }
  } catch (err) {
    if (err?.name === "AbortError") return { ok: false, aborted: true, error: { network: false } };
    return { ok: false, error: { status: 0, code: null, network: true, message: err?.message || "" } };
  }
};

export const LanguageElakayByTUID = async (token, lang, fam) => {
    try{
   const response = await fetch(`${elakay_API}/language/LanguageElakayByTUID?lang=${lang}&fam=${fam}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })
        // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }
   const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors du chargement :", err);
   return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const LanguageElakayBySUID = async (token) => { 
      try{
   const response = await fetch(`${elakay_API}/language/LanguageElakayBySUID`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })
        // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }
   const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors du chargement :", err);
   return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const LanguageElakayByAUID = async (token) => { 
     try{
   const response = await  fetch(`${elakay_API}/language/LanguageElakayByAUID`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })
        // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }
const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors du chargement :", err);
   return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const updateLanguageElakay = async (ID, token, languageInfo) => { 
  try{
   const response = await  fetch(`${elakay_API}/language/updateLanguageElakay/${ID}`, {
        method: "PATCH",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(languageInfo)
    })
        // Vérifie si le statut est une erreur HTTP

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }
 const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors du chargement :", err);
   return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const updateLanguageElakay0 = async (ID, token, languageInfo, coding) => {
     try{
   const response = await  fetch(`${elakay_API}/language/updateLanguageElakay0/${encodePathValue(ID)}?coding=${normalizeBoolean(coding)}`, {
        method: "PATCH",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(languageInfo)
    })
        // Vérifie si le statut est une erreur HTTP
    return await readEncryptedResponse(response);

    } catch (err) {
    console.error("Erreur lors du chargement :", err);
   return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const reorderLanguageElakay0 = async (ID, token, KEY, itemId, position, coding = false) => {
     try{
   const response = await  fetch(`${elakay_API}/language/reorderLanguageElakay0/${encodePathValue(ID)}/${encodePathValue(KEY)}?coding=${normalizeBoolean(coding)}`, {
        method: "PATCH",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ itemId, position })
    })
        // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }
   const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors du chargement :", err);
   return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const deleteLanguageElakay0 = async (ID, IDP, KEY, token, IV, coding = false) => {

      try{
   const query = new URLSearchParams({ coding: String(normalizeBoolean(coding)) });
   const mediaType = normalizeMediaType(IV);
   if (mediaType) query.set("I_V", mediaType);
   const response = await  fetch(`${elakay_API}/language/deleteLanguageElakay0/${encodePathValue(ID)}/${encodePathValue(IDP)}/${encodePathValue(KEY)}?${query.toString()}`, {
        method: "PATCH",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })
        // Vérifie si le statut est une erreur HTTP
    return await readEncryptedResponse(response);

    } catch (err) {
    console.error("Erreur lors du chargement :", err);
   return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const updateLanguageFileUp = async (ID, IDP, KEY, token, language, IV, coding= false) => {
    const mediaType = normalizeMediaType(IV);
    if (!mediaType) {
      return { success: false, error: elakayAutoText("h_b2003cfd31e16f", "Invalid media type.") };
    }
    if (!language) {
      return { success: false, error: elakayAutoText("h_0db01d5f560ef0", "No file uploaded.") };
    }
      try{
    // Type and 10 MB ceiling checked before sending (uploadPolicy).
    let languageInfo = new FormData()
    languageInfo.append('file', await prepareUpload('languageMedia', language))
   const response = await  fetch(`${elakay_API}/language/updateLanguageFileUp/${encodePathValue(ID)}/${encodePathValue(IDP)}/${encodePathValue(KEY)}?I_V=${encodeURIComponent(mediaType)}&coding=${normalizeBoolean(coding)}`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            // "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: languageInfo
    })
        // Vérifie si le statut est une erreur HTTP
    // A proxy HTML page (413) becomes a readable message.
    if (!response.ok && !String(response.headers?.get?.("content-type") || "").includes("json")) await readUploadResponse(response);
    return await readEncryptedResponse(response);

    } catch (err) {
    console.error("Erreur lors du chargement :", err);
   return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const deleteLanguageFileUp = async (ID, IDP, KEY, token, coding = false) => {
  try {
    const response = await fetch(
      `${elakay_API}/language/deleteLanguageFileUp/${encodePathValue(ID)}/${encodePathValue(IDP)}/${encodePathValue(KEY)}?coding=${normalizeBoolean(coding)}`,
      {
        method: "DELETE",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return await readEncryptedResponse(response);
  } catch (err) {
    console.error("Erreur lors de la suppression du fichier :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue",
    };
  }
};

export const SelectDataEmaail = (array, title, value) => {
 try { 
    let objt = array.find(objt => objt.data.title === title)
    if (!objt) {
        throw new Error('no data found in elakay data base language');
      }
    return objt

} catch (err) {
     console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
}
};
